/* Sniggles PDP behavior — variant pills, gallery, live services total, qty
   stepper, mobile sticky bar, and AJAX add-to-bag. Vanilla JS, no framework.
   Auto-inits every [data-sn-pdp] root; all copy comes from data-* attributes
   so this file carries no Liquid. See the cart integration contract in
   sections/sniggles-product.liquid.

   NB (Aug 2): sparse variant matrices. matchVariant() returns null when the
   selected option combination has no corresponding variant (e.g. a product
   sold in Pink/160 and Vanilla/260 but not Pink/260). It used to fall back to
   variants[0], which silently armed Add to Bag with the WRONG item at the
   WRONG price. It now returns null and applyVariant() disables the button.
   Never reintroduce a `|| variants[0]` fallback in currentVariant().

   Oct 11 (FQ website list): pills for sold-out / impossible values carry
   .is-unavailable, recomputed against the other selected options on every
   change; "[percent]% off" sale badge; the description is split at its own
   headings into extra accordions (splitDescription); galleries over 8 media
   show 7 + "View all" (dialog); "You may also like" is fetched from the
   recommendations endpoint and topped up from the subcategory (loadRecs). */
(function () {
  function initPdp(root) {
    if (!root || root.dataset.snPdpReady === '1') return;
    root.dataset.snPdpReady = '1';

    var currency = root.getAttribute('data-currency') || 'USD';
    var settings = {
      addLabel: root.getAttribute('data-add-label') || 'Add to bag',
      soldOut: root.getAttribute('data-soldout-label') || 'Sold out',
      unavailable:
        root.getAttribute('data-unavailable-label') ||
        root.getAttribute('data-soldout-label') ||
        'Unavailable',
      error: root.getAttribute('data-error-label') || 'Something went wrong. Please try again.',
      productTitle: root.getAttribute('data-product-title') || '',
      saleLabel: root.getAttribute('data-sale-label') || '[percent]% off',
      arDigits: root.getAttribute('data-digits') === 'ar'
    };

    function localDigits(str) {
      str = String(str);
      if (!settings.arDigits) return str;
      return str.replace(/[0-9]/g, function (d) { return '٠١٢٣٤٥٦٧٨٩'.charAt(+d); });
    }

    function percentOff(v) {
      if (!v.compare_at_price || v.compare_at_price <= v.price) return 0;
      return Math.floor(((v.compare_at_price - v.price) * 100) / v.compare_at_price);
    }

    var money = function (cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: currency
        }).format((cents || 0) / 100);
      } catch (e) {
        return ((cents || 0) / 100).toFixed(2);
      }
    };

    var form = root.querySelector('[data-pdp-form]');
    var variantInput = root.querySelector('[data-variant-id]');
    var priceBox = root.querySelector('[data-price]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var atb = root.querySelector('[data-add-to-bag]');
    var atbTotal = root.querySelector('[data-atb-total]');
    var atbLabel = root.querySelector('[data-atb-label]');
    var stickyAdd = root.querySelector('[data-sticky-add]');
    var errorBox = root.querySelector('[data-atb-error]');
    var qtyInput = root.querySelector('[data-qty-input]');

    var variants = [];
    try {
      variants = JSON.parse(root.querySelector('[data-pdp-variants]').textContent);
    } catch (e) { variants = []; }

    // ----- Price rendering (matches .sn-price markup) -----
    function priceHTML(variant, withBadge) {
      var sale = variant.compare_at_price && variant.compare_at_price > variant.price;
      var html = '<span class="sn-price' + (sale ? ' sn-price--sale' : '') + '">';
      html += '<span class="sn-price__current money">' + money(variant.price) + '</span>';
      if (sale) html += '<span class="sn-price__was">' + money(variant.compare_at_price) + '</span>';
      html += '</span>';
      var off = percentOff(variant);
      if (withBadge && off > 0) {
        html += '<span class="sn-sale-badge">' +
          settings.saleLabel.replace('[percent]', localDigits(off)) + '</span>';
      }
      return html;
    }

    // ----- Pill availability: crossed out when no in-stock variant has this
    // value together with the other options as currently selected. -----
    function refreshPills() {
      var selected = selectedValues();
      root.querySelectorAll('.sn-pdp__opt').forEach(function (opt, i) {
        opt.querySelectorAll('.sn-pdp__pill').forEach(function (pill) {
          var val = pill.getAttribute('data-option-value');
          var ok = variants.some(function (v) {
            if (!v.available || v.options[i] !== val) return false;
            for (var j = 0; j < selected.length; j++) {
              if (j !== i && selected[j] !== null && v.options[j] !== selected[j]) return false;
            }
            return true;
          });
          pill.classList.toggle('is-unavailable', !ok);
          if (ok) pill.removeAttribute('aria-label');
          else pill.setAttribute('aria-label', val + ' — ' + settings.soldOut);
        });
      });
    }

    // ----- Selected variant, from active pills -----
    function selectedValues() {
      return Array.prototype.map.call(
        root.querySelectorAll('.sn-pdp__opt'),
        function (opt) {
          var active = opt.querySelector('.sn-pdp__pill.is-active');
          return active ? active.getAttribute('data-option-value') : null;
        }
      );
    }

    function matchVariant(values) {
      if (!variants.length) return null;
      // No option pills at all (single-variant product) — the only variant is it.
      if (!values.length || values[0] === null) return variants[0];
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < values.length; j++) {
          if (variants[i].options[j] !== values[j]) { ok = false; break; }
        }
        if (ok) return variants[i];
      }
      // Impossible combination on a sparse matrix. Return null — the caller
      // must disable Add. Do NOT fall back to variants[0].
      return null;
    }

    function currentVariant() {
      return matchVariant(selectedValues());
    }

    // ----- Live total (base + checked services) -----
    function checkedServices() {
      return Array.prototype.filter.call(
        root.querySelectorAll('[data-service]'),
        function (el) { return el.checked; }
      );
    }

    function updateTotal() {
      var v = currentVariant();
      if (!v) {
        if (atbTotal) atbTotal.textContent = '';
        return;
      }
      var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      var svcTotal = checkedServices().reduce(function (sum, el) {
        return sum + (parseInt(el.getAttribute('data-price'), 10) || 0);
      }, 0);
      var grand = v.price * qty + svcTotal;
      if (atbTotal) {
        atbTotal.textContent = svcTotal > 0 ? ' · ' + money(grand) : '';
      }
    }

    // ----- Gallery: scroll-snap stage + dots + thumbs -----
    var stage = root.querySelector('[data-gallery-stage]');
    var dots = root.querySelectorAll('[data-gallery-dot]');
    var thumbs = root.querySelectorAll('[data-gallery-thumb]');

    function setActive(index) {
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
    }

    function goToSlide(index) {
      if (!stage) return;
      var slide = stage.children[index];
      if (!slide) return;
      stage.scrollTo({ left: slide.offsetLeft - stage.offsetLeft, behavior: 'smooth' });
      setActive(index);
    }

    // A variant image can sit beyond the 7 shown when the gallery is capped.
    // Then it is shown in the first slide (original restored on the next
    // visible pick) rather than adding an 8th slide.
    var firstSlide = stage ? stage.children[0] : null;
    var firstSlideHTML = firstSlide ? firstSlide.innerHTML : '';
    var firstSwapped = false;
    function showMedia(index) {
      if (!stage) return;
      var slide = stage.children[index];
      if (!slide) return;
      if (slide.hasAttribute('data-extra')) {
        firstSlide.innerHTML = slide.innerHTML;
        firstSlide.querySelectorAll('img').forEach(function (img) { img.loading = 'eager'; });
        firstSwapped = true;
        goToSlide(0);
        return;
      }
      if (firstSwapped) { firstSlide.innerHTML = firstSlideHTML; firstSwapped = false; }
      goToSlide(index);
    }

    // "View all N photos" dialog
    var dialog = root.querySelector('[data-gallery-dialog]');
    if (dialog) {
      root.querySelectorAll('[data-gallery-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', '');
        });
      });
      var closeBtn = dialog.querySelector('[data-gallery-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { dialog.close ? dialog.close() : dialog.removeAttribute('open'); });
      dialog.addEventListener('click', function (e) { if (e.target === dialog && dialog.close) dialog.close(); });
    }

    // ----- Apply a variant selection -----
    function setButtons(disabled, label) {
      [atb, stickyAdd].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = disabled;
        btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      });
      if (atbLabel) atbLabel.textContent = label;
      if (stickyAdd) stickyAdd.textContent = label;
    }

    function applyVariant() {
      refreshPills();
      var v = currentVariant();

      // Sparse matrix: the chosen combination does not exist as a variant.
      // Clear the posted variant id and lock the button rather than adding
      // the wrong item.
      if (!v) {
        if (variantInput) variantInput.value = '';
        if (atbTotal) atbTotal.textContent = '';
        setButtons(true, settings.unavailable);
        return;
      }

      variantInput.value = v.id;

      if (priceBox) priceBox.innerHTML = priceHTML(v, true);
      if (stickyPrice) stickyPrice.innerHTML = priceHTML(v, false);

      var soldOut = !v.available;
      setButtons(soldOut, soldOut ? settings.soldOut : settings.addLabel);

      if (v.media_id != null) {
        var slides = root.querySelectorAll('[data-slide]');
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-media-id') == String(v.media_id)) {
            showMedia(i);
            break;
          }
        }
      }
      updateTotal();
    }

    // ----- Pill clicks -----
    root.querySelectorAll('.sn-pdp__opt').forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        var pill = e.target.closest('.sn-pdp__pill');
        if (!pill) return;
        opt.querySelectorAll('.sn-pdp__pill').forEach(function (p) {
          p.classList.remove('is-active');
          p.setAttribute('aria-checked', 'false');
        });
        pill.classList.add('is-active');
        pill.setAttribute('aria-checked', 'true');
        applyVariant();
      });
    });

    // ----- Quantity stepper -----
    var qtyDec = root.querySelector('[data-qty-dec]');
    var qtyInc = root.querySelector('[data-qty-inc]');
    function clampQty() {
      var val = parseInt(qtyInput.value, 10);
      if (isNaN(val) || val < 1) val = 1;
      if (val > 99) val = 99;
      qtyInput.value = val;
      if (qtyDec) qtyDec.disabled = val <= 1;
      updateTotal();
    }
    if (qtyDec) qtyDec.addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) - 1; clampQty(); });
    if (qtyInc) qtyInc.addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; clampQty(); });
    if (qtyInput) qtyInput.addEventListener('change', clampQty);

    root.querySelectorAll('[data-service]').forEach(function (el) {
      el.addEventListener('change', updateTotal);
    });

    // ----- Gallery wiring -----
    dots.forEach(function (d) {
      d.addEventListener('click', function () { goToSlide(parseInt(d.getAttribute('data-index'), 10)); });
    });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goToSlide(parseInt(t.getAttribute('data-index'), 10)); });
    });
    if (stage) {
      var scrollTimer;
      stage.addEventListener('scroll', function () {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () {
          var idx = Math.round(stage.scrollLeft / stage.clientWidth);
          setActive(idx);
        }, 80);
      });
    }

    // ----- Mobile sticky bar: appears after the buy row scrolls out of view -----
    var sticky = root.querySelector('[data-sticky]');
    var buyrow = root.querySelector('.sn-pdp__buyrow');
    if (sticky && buyrow && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      }, { threshold: 0 });
      io.observe(buyrow);
    }

    // ----- Add to bag (AJAX) — honors the cart integration contract -----
    function buildItems() {
      var v = currentVariant();
      var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      var items = [{ id: v.id, quantity: qty }];
      checkedServices().forEach(function (el) {
        items.push({
          id: parseInt(el.getAttribute('data-id'), 10),
          quantity: 1,
          properties: {
            _service_of: settings.productTitle,
            _parent_line: String(v.id)
          }
        });
      });
      return items;
    }

    function setBusy(state) {
      [atb, stickyAdd].forEach(function (btn) {
        if (!btn) return;
        if (state) { btn.setAttribute('aria-busy', 'true'); }
        else { btn.removeAttribute('aria-busy'); }
      });
    }

    function addToCart() {
      var v = currentVariant();
      if (!v || !v.available) return;
      if (errorBox) errorBox.textContent = '';
      setBusy(true);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: buildItems() })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw data;
            return data;
          });
        })
        .then(function (data) {
          var items = data.items || (data.id ? [data] : []);
          document.dispatchEvent(new CustomEvent('sniggles:cart:added', { detail: { items: items } }));
          if (window.SnigglesCart && typeof window.SnigglesCart.open === 'function') {
            window.SnigglesCart.open();
          } else {
            fetch('/cart.js')
              .then(function () { window.location.href = '/cart'; })
              .catch(function () { window.location.href = '/cart'; });
          }
        })
        .catch(function (err) {
          if (errorBox) errorBox.textContent = (err && err.description) ? err.description : settings.error;
        })
        .finally(function () { setBusy(false); });
    }

    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(); });
    if (stickyAdd) stickyAdd.addEventListener('click', function () { addToCart(); });

    // Init
    clampQty();
    applyVariant();
    splitDescription(root);
    loadRecs(root);
  }

  /* ---------------------------------------------------------------------
     Description → accordions. Finds the description's own headings (a
     <strong>/<b>/<h2-h6> at the start of a line, e.g. "Features:",
     "Care Instructions", "Recommended Age:") and moves what follows each
     into its own accordion, in a fixed order. Headings that are a label for
     a value on the same line ("Interior Dimensions: approx. 34in") stay in
     the text. "Uses"-type headings stay in Description. Nothing is deleted:
     every node ends up in exactly one section. No headings → untouched.
     --------------------------------------------------------------------- */
  var DESC_ORDER = ['features', 'age', 'dimensions', 'materials', 'care'];
  var DESC_RULES = [
    ['dimensions', /(^|\s)(dimensions?|measurements?)$|^size\s*(&|and)\s*dimensions$|^الأبعاد$|^أبعاد المنتج$|^القياسات$/i],
    ['care', /^(care|washing|cleaning|wash)(\s+(&|and)\s+(cleaning|storage))?(\s+instructions?)?$|^how to (clean|wash|care)\b|^العناية$|^تعليمات العناية$|^طريقة (التنظيف|الغسيل|العناية)$|^التنظيف$|^الغسيل$/i],
    ['materials', /^(materials?|fabrics?|composition|materials?\s*(&|and)\s*care)$|^الخامات?$|^المواد$|^المادة$|^القماش$|^الخامات والعناية$/i],
    ['age', /^((recommended|suitable)\s+)?age(\s+(recommendation|range|group))?$|^suitable for$|^(size|sizes|sizing|capacity|weight|age\s*(&|and)\s*size)$|^العمر(\s+المناسب|\s+الموصى به)?$|^الفئة العمرية$|^المقاس(ات)?$|^الحجم$|^السعة$|^الوزن$|^العمر والمقاس$/i],
    ['features', /^(key\s+|product\s+)?features?$|^highlights$|^benefits$|^المميزات$|^المزايا$|^مميزات المنتج$|^الميزات$|^الخصائص$|^أبرز (المزايا|الميزات|المميزات)$/i],
    ['desc', /^(uses|how to use|ideal for|use|usage|what it does|الاستخدامات|طريقة الاستخدام|الاستخدام)$/i]
  ];
  var BLOCKS = /^(P|DIV|UL|OL|LI|H[1-6]|TABLE|BLOCKQUOTE|SECTION)$/;

  function headingKey(el) {
    var t = (el.textContent || '').replace(/\s+/g, ' ').replace(/[\s:：\-–—]+$/, '').trim();
    if (!t || t.length > 40) return null;
    for (var i = 0; i < DESC_RULES.length; i++) {
      if (DESC_RULES[i][1].test(t)) return DESC_RULES[i][0];
    }
    return null;
  }

  function prevMeaningful(n) {
    var p = n.previousSibling;
    while (p && p.nodeType === 3 && !p.textContent.replace(/ /g, ' ').trim()) p = p.previousSibling;
    while (p && p.nodeType === 1 && /^(STRONG|B)$/.test(p.nodeName) && !p.textContent.trim()) {
      p = p.previousSibling;
      while (p && p.nodeType === 3 && !p.textContent.replace(/ /g, ' ').trim()) p = p.previousSibling;
    }
    return p;
  }

  function atLineStart(el, body) {
    var n = el;
    while (n && n !== body) {
      var p = prevMeaningful(n);
      if (p) return p.nodeName === 'BR' || BLOCKS.test(p.nodeName);
      n = n.parentNode;
      if (n === body || BLOCKS.test(n.nodeName)) return true;
    }
    return true;
  }

  // Text on the same line after the heading → it is a "Label: value" pair.
  function hasInlineValue(el, body) {
    var n = el;
    while (n && n !== body) {
      var s = n.nextSibling;
      while (s) {
        if (s.nodeName === 'BR' || (s.nodeType === 1 && BLOCKS.test(s.nodeName))) return false;
        if ((s.textContent || '').replace(/ /g, ' ').trim()) return true;
        s = s.nextSibling;
      }
      n = n.parentNode;
      if (!n || n === body || BLOCKS.test(n.nodeName)) return false;
    }
    return false;
  }

  function tidy(container) {
    // Drop empty inline wrappers, then empty blocks, then edge/excess <br>s.
    container.querySelectorAll('strong, b, span, em').forEach(function (e) {
      if (!e.textContent.replace(/ /g, ' ').trim() && !e.querySelector('img,iframe,video')) e.remove();
    });
    var changed = true;
    while (changed) {
      changed = false;
      container.querySelectorAll('p, li, ul, ol, div').forEach(function (e) {
        if (!e.textContent.replace(/ /g, ' ').trim() && !e.querySelector('img,iframe,video,table')) { e.remove(); changed = true; }
      });
    }
    container.querySelectorAll('p, li, div').forEach(function (e) {
      while (e.firstChild && (e.firstChild.nodeName === 'BR' || (e.firstChild.nodeType === 3 && !e.firstChild.textContent.replace(/ /g, ' ').trim()))) e.removeChild(e.firstChild);
      while (e.lastChild && (e.lastChild.nodeName === 'BR' || (e.lastChild.nodeType === 3 && !e.lastChild.textContent.replace(/ /g, ' ').trim()))) e.removeChild(e.lastChild);
    });
    while (container.firstChild && (container.firstChild.nodeName === 'BR' || (container.firstChild.nodeType === 3 && !container.firstChild.textContent.replace(/ /g, ' ').trim()))) container.removeChild(container.firstChild);
    // Collapse 3+ consecutive <br> into two.
    container.querySelectorAll('br').forEach(function (br) {
      var n = br.nextSibling, run = [];
      while (n && (n.nodeName === 'BR' || (n.nodeType === 3 && !n.textContent.replace(/ /g, ' ').trim()))) {
        if (n.nodeName === 'BR') run.push(n);
        n = n.nextSibling;
      }
      if (run.length > 1) run.slice(1).forEach(function (x) { if (x.parentNode) x.remove(); });
    });
  }

  function splitDescription(root) {
    var acc = root.querySelector('[data-desc-acc]');
    if (!acc || acc.dataset.split === '1') return;
    var body = acc.querySelector('.sn-pdp__acc-body');
    if (!body) return;

    var markers = [];
    body.querySelectorAll('strong, b, h2, h3, h4, h5, h6').forEach(function (el) {
      if (el.parentNode && el.parentNode.closest && el.parentNode.closest('strong, b')) return;
      var key = headingKey(el);
      if (!key || !atLineStart(el, body)) return;
      markers.push({ el: el, key: key, keep: key === 'desc' || hasInlineValue(el, body) });
    });
    if (!markers.some(function (m) { return m.key !== 'desc'; })) return;
    acc.dataset.split = '1';

    var parts = {};
    // Extract from the last heading backwards so earlier ranges stay valid.
    for (var k = markers.length - 1; k >= 0; k--) {
      var m = markers[k];
      m.el.setAttribute('data-sn-marker', '1');
      var range = document.createRange();
      range.setStartBefore(m.el);
      range.setEnd(body, body.childNodes.length);
      var frag = range.extractContents();
      var holder = document.createElement('div');
      holder.appendChild(frag);
      var mk = holder.querySelector('[data-sn-marker]');
      if (mk) {
        if (m.keep) mk.removeAttribute('data-sn-marker');
        else mk.remove();
      }
      tidy(holder);
      (parts[m.key] = parts[m.key] || []).unshift(holder);
    }
    body.querySelectorAll('[data-sn-marker]').forEach(function (e) { e.removeAttribute('data-sn-marker'); });

    // "Uses"-type sections go back into Description, in order.
    (parts.desc || []).forEach(function (h) { while (h.firstChild) body.appendChild(h.firstChild); });
    tidy(body);

    var after = acc;
    DESC_ORDER.forEach(function (key) {
      var list = parts[key];
      if (!list || !list.length) return;
      var d = document.createElement('details');
      d.className = 'sn-pdp__acc sn-pdp__acc--desc';
      d.setAttribute('data-desc-part', key);
      var s = document.createElement('summary');
      s.className = 'sn-pdp__acc-summary';
      s.textContent = acc.getAttribute('data-h-' + key) || key;
      var b = document.createElement('div');
      b.className = 'sn-pdp__acc-body rte';
      list.forEach(function (h) { while (h.firstChild) b.appendChild(h.firstChild); });
      if (!b.textContent.replace(/ /g, ' ').trim()) return;
      d.appendChild(s);
      d.appendChild(b);
      after.insertAdjacentElement('afterend', d);
      after = d;
    });

    // The description began with a heading → nothing left for "Description".
    if (!body.textContent.replace(/ /g, ' ').trim() && !body.querySelector('img,iframe,video')) acc.remove();
  }

  /* ---------------------------------------------------------------------
     You may also like: Shopify related recommendations, topped up from the
     breadcrumb subcategory when fewer than 4 come back. Cards are rendered
     server-side by sections/sniggles-recommendations.liquid.
     --------------------------------------------------------------------- */
  function loadRecs(root) {
    var box = root.querySelector('[data-recs]');
    if (!box || box.dataset.loaded === '1') return;
    box.dataset.loaded = '1';
    var track = box.querySelector('[data-recs-track]');
    var exclude = (box.getAttribute('data-exclude') || '').split(',').filter(Boolean);
    var MAX = 6, MIN = 4;
    var seen = {};
    exclude.forEach(function (id) { seen[id] = true; });

    function cellsFrom(url) {
      if (!url) return Promise.resolve([]);
      return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          if (!html) return [];
          var doc = new DOMParser().parseFromString(html, 'text/html');
          return Array.prototype.slice.call(doc.querySelectorAll('[data-rec-id]'));
        })
        .catch(function () { return []; });
    }

    function add(cells) {
      cells.forEach(function (c) {
        var id = c.getAttribute('data-rec-id');
        if (seen[id] || track.children.length >= MAX) return;
        seen[id] = true;
        track.appendChild(document.importNode(c, true));
      });
    }

    cellsFrom(box.getAttribute('data-url'))
      .then(function (cells) {
        add(cells);
        if (track.children.length >= MIN) return null;
        return cellsFrom(box.getAttribute('data-fallback-url')).then(add);
      })
      .then(function () {
        if (track.children.length > 0) box.hidden = false;
      });
  }

  function boot() {
    document.querySelectorAll('[data-sn-pdp]').forEach(initPdp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-init when a section is re-rendered in the theme editor
  document.addEventListener('shopify:section:load', boot);
})();